// extracted by mini-css-extract-plugin
export default {"button":"ak-z","reviewSort":"bk-z"};